<div (click)="selectedCard()" [ngStyle]="{ cursor: hasPointer ? 'pointer' : 'default' }">
	<h5 class="tab-content__title">TYPE</h5>
	<span class="tab-content__text">{{ info.type || info.photoType }}</span>
	<h5 class="tab-content__title" *ngIf="contentType === tabs.TAB_TITLES.INTERIOR">
		LEVEL
	</h5>
	<span class="tab-content__text" *ngIf="contentType === tabs.TAB_TITLES.INTERIOR">{{ info.level }}</span>
</div>
